export default __webpack_public_path__ + "static/media/2003.e9a41929.png";